// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { OptionGroup } from "../OptionGroup"
import { Checkbox } from "../Checkbox"
import { useI18n } from "@/i18n"
import type { AnswerDraft } from "../types"

interface Props {
  value: AnswerDraft
  onChange: (patch: AnswerDraft) => void
}

/** Step 3 (wire) — goal + target-review acknowledgement. */
export function Step3Goal({ value, onChange }: Props) {
  const { t } = useI18n()
  const goalType = (value.goalType as string | undefined) ?? null
  const acknowledged = value.targetAcknowledged === true

  return (
    <div className="flex flex-col gap-4">
      <OptionGroup
        legend={t("onboarding.step3.title")}
        columns={3}
        value={goalType}
        onChange={next => onChange({ goalType: next, targetAcknowledged: acknowledged })}
        options={[
          {
            value: "maintain",
            label: t("onboarding.step3.maintain"),
            sublabel: t("onboarding.step3.maintainSub"),
          },
          {
            value: "loss",
            label: t("onboarding.step3.loss"),
            sublabel: t("onboarding.step3.lossSub"),
          },
          {
            value: "gain",
            label: t("onboarding.step3.gain"),
            sublabel: t("onboarding.step3.gainSub"),
          },
          {
            value: "improve_health",
            label: t("onboarding.step3.improve"),
            sublabel: t("onboarding.step3.improveSub"),
          },
        ]}
      />
      <label className="flex items-start gap-2 text-sm text-ink">
        <Checkbox
          id="onboarding-step3-ack"
          checked={acknowledged}
          onCheckedChange={checked => onChange({ goalType, targetAcknowledged: checked })}
        />
        <span>{t("onboarding.step3.ackLabel")}</span>
      </label>
    </div>
  )
}
